// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/trip/entry_requirements.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_papers } from "../core/papers_pb";

/**
 * Describes the file proto/model/trip/entry_requirements.proto.
 */
export const file_proto_model_trip_entry_requirements = /*@__PURE__*/
  fileDesc("Cilwcm90by9tb2RlbC90cmlwL2VudHJ5X3JlcXVpcmVtZW50cy5wcm90bxIGY2FybWVuIqwBChBWaXNhUmVxdWlyZW1lbnRzEhMKC3RyYXZlbGVyX2lkGAEgASgJEhwKFHRyYXZlbGVyX25hdGlvbmFsaXR5GAIgASgJEhMKC2V4cGxhbmF0aW9uGAMgASgJEiUKDXJlcXVpcmVkX3Zpc2EYBCABKAsyDi5jYXJtZW4uUGFwZXJzEikKBnN0YXR1cxgFIAEoDjIZLmNhcm1lbi5SZXF1aXJlbWVudFN0YXR1cyKdAQoTTWVkaWNhbFJlcXVpcmVtZW50cxITCgt0cmF2ZWxlcl9pZBgBIAEoCRIcChR0cmF2ZWxlcl9uYXRpb25hbGl0eRgCIAEoCRITCgtleHBsYW5hdGlvbhgDIAEoCRITCgtyZXF1aXJlbWVudBgEIAEoCRIpCgZzdGF0dXMYBSABKA4yGS5jYXJtZW4uUmVxdWlyZW1lbnRTdGF0dXMiugEKEUVudHJ5UmVxdWlyZW1lbnRzEh0KFWVudHJ5X3JlcXVpcmVtZW50c19pZBgBIAEoCRIWCg5kZXN0aW5hdGlvbl9pZBgCIAEoCRIzChF2aXNhX3JlcXVpcmVtZW50cxgDIAMoCzIYLmNhcm1lbi5WaXNhUmVxdWlyZW1lbnRzEjkKFG1lZGljYWxfcmVxdWlyZW1lbnRzGAQgAygLMhsuY2FybWVuLk1lZGljYWxSZXF1aXJlbWVudHMq3AEKEVJlcXVpcmVtZW50U3RhdHVzEiIKHlJFUVVJUkVNRU5UX1NUQVRVU19VTlNQRUNJRklFRBAAEh4KGlJFUVVJUkVNRU5UX1NUQVRVU19QRU5ESU5HEAESIgoeUkVRVUlSRU1FTlRfU1RBVFVTX0lOX1BST0dSRVNTEAISIAocUkVRVUlSRU1FTlRfU1RBVFVTX0NPTVBMRVRFRBADEh0KGVJFUVVJUkVNRU5UX1NUQVRVU19GQUlMRUQQBBIeChpSRVFVSVJFTUVOVF9TVEFUVVNfSUdOT1JFRBAFQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM", [file_proto_model_core_papers]);

/**
 * Describes the message carmen.VisaRequirements.
 * Use `create(VisaRequirementsSchema)` to create a new message.
 */
export const VisaRequirementsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_entry_requirements, 0);

/**
 * Describes the message carmen.MedicalRequirements.
 * Use `create(MedicalRequirementsSchema)` to create a new message.
 */
export const MedicalRequirementsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_entry_requirements, 1);

/**
 * Describes the message carmen.EntryRequirements.
 * Use `create(EntryRequirementsSchema)` to create a new message.
 */
export const EntryRequirementsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_entry_requirements, 2);

/**
 * Describes the enum carmen.RequirementStatus.
 */
export const RequirementStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_trip_entry_requirements, 0);

/**
 * @generated from enum carmen.RequirementStatus
 */
export const RequirementStatus = /*@__PURE__*/
  tsEnum(RequirementStatusSchema);

